import React, { Component } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  LogInAuthData,
  RegAuthData,
  ForgotPassAuthData,
  RegisterVerifyAuthData,
} from "../modules/auth";
import apiCall from "../modules/common/utils/apiCall";
import { Numbers } from "../modules/components/Numbers";
import { Category } from "../modules/components/Category";
import { Badge } from "../modules/components/Badge";
import { Blogs } from "../modules/components/Blogs"
import { Users } from "../modules/components/Users";
import { HomeConfig } from "../modules/components/HomeConfig";
import { Orders } from "../modules/components/Orders";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { activeUser } from "../modules/common/redux/actions";

let mountLimit = 1;

class Router extends Component {
  state = {
    currentUser: {},
    isUserVerified: false,
  };

  async componentDidMount() {
    if (mountLimit == 1) {
      mountLimit++;
      try {
        const { result } = await apiCall("REACT_APP_CURRENT_USER_URL", "GET");
        if (result && result.success) {
          if (result.user.accessLevel > 2) {
            window.localStorage.removeItem("token");
            this.setState({ isUserVerified: false, currentUser: {} });
            this.props.activeUser({ isUserVerified: false, currentUser: {} });
            toast.error("only admin / seller can access this panel");
          } else {
            this.setState({ isUserVerified: true, currentUser: result.user });
            this.props.activeUser({
              isUserVerified: true,
              currentUser: result.user,
            });
          }
        } else {
          window.localStorage.removeItem("token");
          this.setState({ isUserVerified: false, currentUser: {} });
          this.props.activeUser({ isUserVerified: false, currentUser: {} });
        }
      } catch (error) {
        console.log("Router.js::componentDidMount Error ::", error);
        window.localStorage.removeItem("token");
        this.setState({ isUserVerified: false });
        this.props.activeUser({ isUserVerified: false, currentUser: {} });
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }

  renderLogin = () => {
    return (
      <Routes>
        <Route path="/*" element={<LogInAuthData />}></Route>
        <Route path="/login" element={<LogInAuthData />}></Route>
        <Route path="/registration" element={<RegAuthData />}></Route>
        <Route path="/forgotpassword" element={<ForgotPassAuthData />}></Route>
        <Route
          path="/verification"
          element={<RegisterVerifyAuthData />}
        ></Route>
      </Routes>
    );
  };

  renderComponents = () => {
    return (
      <Routes>
        <Route
          path="/"
          element={
            this.state.isUserVerified ? (
              <Navigate to="/admin/numbers" />
            ) : (
              <Navigate to="/login" />
            )
          }
        ></Route>
        <Route path="/admin/numbers" element={<Numbers />}></Route>
        <Route path="/admin/category" element={<Category />}></Route>
        <Route path="/admin/badge" element={<Badge />}></Route>
        <Route path="/admin/users" element={<Users />}></Route>
        <Route path="/admin/homeConfig" element={<HomeConfig />}></Route>
        <Route path="/admin/orders" element={<Orders />}></Route>
        <Route path="/admin/blogs" element={<Blogs/>}></Route>
        <Route
          path="/verification"
          element={<RegisterVerifyAuthData />}
        ></Route>
      </Routes>
    );
  };

  render() {
    if (!this.state.isUserVerified) {
      return this.renderLogin();
    } else {
      return this.renderComponents();
    }
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, { activeUser })(Router);
